import { render, staticRenderFns } from "./PaginatedItems.vue?vue&type=template&id=00119474&scoped=true&lang=pug&"
import script from "./PaginatedItems.vue?vue&type=script&lang=js&"
export * from "./PaginatedItems.vue?vue&type=script&lang=js&"
import style0 from "./PaginatedItems.vue?vue&type=style&index=0&id=00119474&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00119474",
  null
  
)

/* custom blocks */
import block0 from "./PaginatedItems.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports